<script>
import { Line } from "vue-chartjs";
import { numeral } from "numeral";
export default {
  extends: Line,
  props: {
    chartdata: {
      type: Array,
      default: null,
    },
  },
  watch: {
    chartdata: "render",
  },
  methods: {
    render() {
      var length = this.chartdata.length;

      var array = this.chartdata;
      // Create new arrays to store the data
      var forksArray = [];
      var starsArray = [];
      var watchersArray = [];
      var timeStampArray = [];

      for (var i = 0; i < length; i++) {
        // Then push our data to the new arrays
        forksArray.push(array[i] ? array[i].forkCount : "");
        starsArray.push(array[i] ? array[i].starCount : "");
        watchersArray.push(array[i] ? array[i].watcherCount : "");
        timeStampArray.push(
          array[i] ? this.frontEndDate(array[i].timestamps) : ""
        );
      }

      this.renderChart(
        {
          labels: timeStampArray,
          datasets: [
            {
              label: "Forks",
              borderColor: "#F5D56A",
              fill: false,
              lineTension: 0,
              data: forksArray,
            },
            {
              label: "Stars",
              borderColor: "#f56a6a",
              fill: false,
              lineTension: 0,
              data: starsArray,
            },
            {
              label: "Watchers",
              borderColor: "#6AB2F5",
              fill: false,
              lineTension: 0,
              data: watchersArray,
            },
          ],
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: (value) => numeral(value).format("$0,0"),
                  },
                },
              ],
            },
            tooltips: {
              mode: "index",
              callbacks: {
                label(tooltipItem, data) {
                  const label = data.datasets[tooltipItem.datasetIndex].label;
                  const value = numeral(tooltipItem.yLabel).format("$0,0");

                  return `${label}: ${value}`;
                },
              },
            },
          },
          steppedLine: true,
        },
        {
          responsive: true,
        }
      );
    },
    frontEndDate(date) {
      date = date.toString();
      date = date.split("T")[0];

      return date;
    },
  },
  mounted() {
    this.render();
  },
};
</script>
